import React from 'react'
import Link from 'next/link'

export default function InfographicSection({ pageTitle, hrefLink }) {
    return (
        <>
            <h3 className='text-xl font-semibold text-black border-l-4 border-[#1b5df3] pl-2 bg-[#ecf5fe] py-4'>Infographics :-
                <Link href={hrefLink} target='_blank'>
                    <span className='text-base font-normal text-[#1b5df3] underline'>{pageTitle}</span>
                </Link>
            </h3>
        </>
    )
}
